module.exports = __webpack_public_path__ + "static/media/Daniel Halladay Headshot_1738575071221.0aad24fd.png";